module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  total=\"$ctrl.total\"\n  limit=\"$ctrl.limit\"\n  item-state=\"event\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  resource=\"MarketingEvents\"\n  title=\"Events\"\n  transformer=\"EventsTransforms\"\n  no-items-text=\"No Events Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/events/events.html
// module id = 1905
// module chunks = 0